<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/foundation/news">Foundation </a></li>
                            <li><a routerLink="/trustees" class="active">Trustees</a></li>
                            <!-- <li><a href="javascript:void(0);" >Leicestershire Cricket Society</a></li>
                            <li><a href="javascript:void(0);">Coaching Camps</a></li>
                            <li><a routerLink="/cricket"> Mike Turner Indoor Cricket Centre</a></li>                                                                                      -->
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <!-- <div class="community-foundation-bg">
        <div class="container">
            <div class="community-foundation-detail">
                <a href="javascript:void(0)">
                    <img src="assets/images/foundation-launch-web-new.png">
                </a>
            </div>
        </div>
    </div> -->
    <div class="community-foundation-donate cf">
        <div class="container">
            <div class="community-tab-about cf">
                <div class="academy-graduates-bottom cf" *ngIf="communitystaffList?.length > 0">
                    <div class="academy-our-strategy-top-titel">
                        <h2 class="titel-name">Trustee members</h2>
                     </div>
                    <div class="sub-committe-detail cf">
                        <ngx-slick-carousel class="carousel" slickModal="slick-carousel"[config]="slideourstaffConfig">
                            <div ngxSlickItem class="player-staff-box slide" *ngFor="let staff of communitystaffList">
                                <a href="#login-box-{{staff.community_trusty_id}}" class="popup-login1">
                                    <img [src]="staff?.image" >
                                    <div class="player-staff-box-overlay">
                                        <h4>{{staff?.name}}</h4>
                                        <p>{{staff?.designation}}</p>
                                    </div> 
                                </a>
                                <div class="login-section-for-login-section matchday mfp-hide " id="login-box-{{staff.community_trusty_id}}">
                                    <div class="player-staff-box-overlay">
                                        <h4>{{staff?.name}}</h4>
                                        <p>{{staff?.designation}}</p>
                                        <div [innerHTML]="staff?.description"></div>
                                    </div>
						        </div>
                            </div>
                        </ngx-slick-carousel>
                    </div>
                </div>
               
            </div>
           
              
        </div>
    </div>
</section><!-- page ends-->